<div class="page-layout simple fullwidth" *ngIf="factura">
    <!-- HEADER -->
    <div class="header accent p-24" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="row" fxLayoutAlign="start center">
            <button
                mat-icon-button
                class="mr-0 mr-sm-16"
                [routerLink]="'/facturas'"
            >
                <mat-icon>arrow_back</mat-icon>
            </button>

            <div
                fxLayout="column"
                fxLayoutAlign="start start"
                [@animate]="{
                    value: '*',
                    params: { delay: '100ms', x: '-25px' }
                }"
            >
                <div class="h2">Factura {{ factura.numero }}</div>

                <div class="subtitle secondary-text">
                    <span>Detalle</span>
                </div>
            </div>
        </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->

    <div class="center p-24 pb-56" fusePerfectScrollbar>
        <div class="content">
            <div class="mat-card mat-elevation-z2 p-24" fxLayout="column">
                <mat-tab-group dynamicHeight="true">
                    <mat-tab label="Factura">
                        <div class="p-24">
                            <app-factura-oocc
                                [factura]="factura"
                                [origen]="origen"
                                (toggleEstadoFacturaEvent)="
                                    cambiarEstadoFactura($event)
                                "
                            ></app-factura-oocc>
                        </div>
                    </mat-tab>
                    <mat-tab
                        [label]="
                            'Órdenes de Compra (' +
                            factura.ordenesCompra.length +
                            ')'
                        "
                    >
                        <app-tabla-oocc
                            *ngIf="factura.ordenesCompra"
                            [oocc]="factura.ordenesCompra"
                            [configuracion]="configuracionOOCC"
                        >
                        </app-tabla-oocc>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
    <!-- / CONTENT -->
</div>
